module.exports = __webpack_public_path__ + "static/otm_all-b9b72d67ec7e31ecca06317d7d1da4e9.png";